import React, {useMemo} from "react";
import {graphql} from "gatsby";
import {
    StrapiLayout,
    OpenPageCardsContainer
} from "@klear/open-site";
const {Helmet} = require("react-helmet");

const PREFIX = 'https://klear.com/features/';


export default ({data}) => {
    const feature = data.allStrapiFeature.edges[0].node;
    const cards = data.allStrapiFeature.edges[0].node.feature_card;
    const footerData = data.strapiFooter;

    const topCardContent = useMemo(() =>
        <img src={feature.topCard.image?.url} alt=""/>
    , []);

    return (
        <StrapiLayout footerProps={footerData}>
            <Helmet>
                <title>{feature.title}</title>
                <meta name="description" content={feature.description}/>
                {feature.topImage &&
                <meta name="image" content={feature.topImage}/> &&
                <meta property="og:image" content={feature.topImage}/>}
                <link rel="canonical" href={`${PREFIX}${feature.slug}/`} />
            </Helmet>
            <OpenPageCardsContainer
            showDemoRequestCard={true} horizontalTopCard={feature.horizontalTopCard} modalType={feature.modalType}
            topCard={{...feature.topCard, bigContent: true, topCardContent}} middleCards={cards} demoRequestBottomCard={feature.requestDemoSection}
            />
        </StrapiLayout>
    );
};
export const query = graphql`
  query($slug: String!) {
  allStrapiFeature(filter: { slug: { eq: $slug } }) {
        edges {
          node {
        slug
        title
        topCard {
          title
          description
          image {
            url
          }
          backgroundShape {
            color
            shapeId
            side
          }
          sectionPadding
        }
        feature_card {
          title
          description
          image {
            url
          }
          backgroundShape {
            color
            shapeId
            side
          }
          sectionPadding
        }
        requestDemoSection {
          title
          subtitle
        }
        description
        topImage
        sectionTitle
      }
    }
  }
  strapiFooter {
        columns {
          title
          links {
            text
            url
          }
        }
        backgroundShapes {
            color
            shapeId
            side
        }
      }
}
`;